import {
  YoutubeIcon_default
} from "./chunk-2GXNIYQL.mjs";
export {
  YoutubeIcon_default as default
};
